import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=3ef59142"
import script from "./sdk.vue?vue&type=script&lang=js"
export * from "./sdk.vue?vue&type=script&lang=js"
import style0 from "./sdk.vue?vue&type=style&index=0&id=3ef59142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports